import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import "../../FinanceGridFinance.css";
import moment from "moment";
import MuiPagination from "../FeatureComponents/Pagination";
import DynamicTable from "../FeatureComponents/DynamicTable";
import SearchComponent from "../FeatureComponents/SearchComponent";
import TabsComponent from "../FeatureComponents/TabsComponent";
import axios from "axios";

function AyekartFintechFinanceGrids() {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const navigate = useNavigate();
  const loc = useLocation();
  const [loading, setLoading] = useState(false);

  // ================================

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [activeTab, setActiveTab] = useState(loc?.state?.activeTab || 0);
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState([
    { name: "Pending", count: 0 },
    { name: "Approved", count: 0 },
    { name: "Payment Done", count: 0 },
    { name: "Cancelled", count: 0 },
  ]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const headersMap = {
    0: [
      { label: "ID", key: "id" },
      { label: "Created At", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "L1 Status", key: "l1_status" },
      { label: "L2 Status", key: "l2_status" },
      { label: "Pending Actioner", key: "pending_actioner",default: "--NA--" },
      { label: "Actioner", key: "actioner" },
    ],
    1: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
    2: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
    3: [
      { label: "Grid No", key: "id" },
      { label: "Date", key: "created_at" },
      { label: "Total Orders", key: "total_orders" },
      { label: "Actioner", key: "actioner" },
    ],
  };

  const handleNavigation = (navigate, id) => {
    const indexInPage = tableData.findIndex((row) => row.id === id);
    const gridPage =
      indexInPage >= 0 ? (page - 1) * limit + indexInPage + 1 : 1;

    navigate("/ayekart-fintech/finance-grid-view", {
      state: {
        id,
        activeTab,
        gridPage,
        totalGrids: tabData[activeTab]?.count || 0,
        searchQuery: debouncedSearch || "",
      },
    });
  };

  // Fetch data from API
  const handleSearch = (query) => {
    setPage(1);
    setSearchQuery(query);
  };

  const fetchDataCounts = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `/workflow/api/orders/grids_count?org_id=3`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.data?.status) {
        setTabData((prevTabs) =>
          prevTabs.map((tab) => {
            let key = tab.name.toLowerCase();
            if (key === "payment done") key = "paid";
            if (key === "cancelled") key = "rejected";
            return {
              ...tab,
              count: response.data.counts[key] || 0,
            };
          })
        );
      } else {
        console.error("Failed to fetch tab counts.");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const tabNames = ["Pending", "Approved", "Paid", "Rejected"];
    const selectedTab = tabNames[activeTab] || "Pending";
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const data = await fetch(
        `/workflow/api/orders/grids?org_id=3&tab_name=${selectedTab}&page=${page}&limit=${10}${
          debouncedSearch ? "&id=" + debouncedSearch : ""
        }`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const response = await data.json();
      if (response?.status) {
        setTableData(response?.grids || []);
        if (response?.total_records) {
          setTabData((prev) =>
            prev.map((tab, index) => ({
              ...tab,
            }))
          );
        }
      } else {
        setTableData([]);
      }
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeTab, page, debouncedSearch]);

  const handleTabChange = (event, newValue) => {
    setPage(1);
    setActiveTab(newValue);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);

    return () => clearTimeout(handler);
  }, [searchQuery]);
  // ================================

  useEffect(() => {
    if (userDetails?.user_category !== "Finance") {
      toast.error("Access denied");
      navigate("/");
    }
    fetchDataCounts();
  }, []);

  return (
    <div className="container-fluid mt-4">
      <Loader loading={loading} />

      <div className="container-fluid border bg-light rounded-3 px-0 py-3">
      <div className="py-2 px-3 flex justify-between items-center">
        <TabsComponent
          tabData={tabData}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
        {/* Search bar */}
        <div className="max-w-[200px]">
          <SearchComponent onSearch={handleSearch} />
        </div>
      </div>

      <DynamicTable
        headers={headersMap[activeTab]}
        data={tableData}
        action={handleNavigation}
      />

      <div className="flex justify-start pl-2">
        <MuiPagination
          page={page}
          limit={limit}
          totalRecords={tabData[activeTab]?.count || 1}
          onPageChange={(newPage) => setPage(newPage)}
        />
      </div>
      </div>
    </div>
  );
}

export default AyekartFintechFinanceGrids;
